import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import App from './App'

if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
        dsn: 'https://4f8d7fbd1d5242aea905b63da0035e4c@o459966.ingest.sentry.io/4504820704608256',
        integrations: [new Integrations.BrowserTracing()],
        // This is the git SHA
        release: process.env.REACT_APP_GIT_SHA,

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    })
}

ReactDOM.render(<App />, document.getElementById('app'))
